<script setup lang="ts">
  import { ref } from "vue";
  import { Text, IconBasket } from "@ui-kit";
  import { Image } from "@src/components";

  const { imageUrl, article, hasEpc, hasAlarm, size } = defineProps<{
    imageUrl: string;
    article: string;
    hasEpc: boolean;
    hasAlarm: boolean;
    size?: string;
  }>();
  const emit = defineEmits<{ "delete": [value: void] }>();

  let startX = 0;
  let currentX = 0;
  const SWIPE_THRESHOLD = 100; // Порог в пикселях для срабатывания удаления

  const swipeOffset = ref(0);

  const handleTouchStart = (e: TouchEvent) => {
    startX = e.touches[0].clientX;
    currentX = startX;
  };

  const handleTouchMove = (e: TouchEvent) => {
    currentX = e.touches[0].clientX;
    const diff = currentX - startX;

    if (diff < 0) {
      const element = e.currentTarget as HTMLElement;
      element.style.transform = `translateX(${diff}px)`;
      swipeOffset.value = Math.abs(diff);
    }
  };

  const handleTouchEnd = (e: TouchEvent) => {
    const element = e.currentTarget as HTMLElement;
    const diff = currentX - startX;

    if (diff < -SWIPE_THRESHOLD) {
      element.style.transform = "translateX(-100%)";
      element.addEventListener(
        "transitionend",
        () => {
          console.log("delete");
          emit("delete");
        },
        { once: true },
      );
    } else {
      element.style.transform = "translateX(0)";
    }
    swipeOffset.value = 0;
  };
</script>

<template>
  <div class="check-alarming-item-wrapper">
    <div class="check-alarming-item-background">
      <div>
        <IconBasket style="stroke: var(--sf-tag-text-error)" />
      </div>
    </div>
    <div class="check-alarming-item" @touchstart="handleTouchStart" @touchmove="handleTouchMove" @touchend="handleTouchEnd">
      <Image :url="imageUrl" />
      <div class="check-alarming-item__info">
        <Text font="body-regular-14">{{ `${article}${size ? ` (${size})` : ""}` }}</Text>
        <div class="check-alarming-item__status-container">
          <div class="check-alarming-item__status" :class="{ 'check-alarming-item__status--success': hasEpc }">
            <Text :color="hasEpc ? 'success' : 'secondary'">{{ $t("EPC") }}</Text>
          </div>
          <div class="check-alarming-item__status" :class="{ 'check-alarming-item__status--success': hasAlarm }">
            <Text :color="hasAlarm ? 'success' : 'secondary'">
              {{ $t("Аларм") }}
            </Text>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .check-alarming-item-wrapper {
    position: relative;
    overflow: hidden;
    border-radius: 16px;
    width: 100%;
  }

  .check-alarming-item-background {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: var(--sf-tag-background-error);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 20px;
    border-radius: 16px;
  }

  .delete-icon {
    opacity: v-bind(swipeOffset / SWIPE_THRESHOLD);
  }

  .check-alarming-item {
    position: relative;
    background-color: white;
    display: flex;
    gap: 12px;
    transition: transform 0.2s ease;
  }

  .check-alarming-item :deep(.image) {
    width: 52px;
    height: 60px;
  }

  .check-alarming-item__info {
    display: flex;
    flex-direction: column;
    gap: 6px;
    flex: 1;
  }

  .check-alarming-item__status-container {
    display: flex;
    border-radius: 12px;
    overflow: hidden;
  }

  .check-alarming-item__status {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;
    padding: 8px;
    background-color: var(--sf-base-background-secondary);
  }

  .check-alarming-item__status--success {
    background-color: var(--sf-base-background-success);
  }
</style>
